import { Icd10Code } from '@alberta/konexi-shared';
import { ISearchable } from 'src/app/common/contracts/components/searchable';

export { Icd10Code };

/**
 * DTO für ICD-10-GM Diagnosen mit Suchfunktionalität.
 *
 * Wird vom Icd10Service für die Suche in der eingebetteten ICD-10-Datenbank
 * verwendet und als DTO für das Autocomplete-Control bereitgestellt.
 *
 * @see {@link Icd10Service}
 */
export class Icd10Dto implements Icd10Code, ISearchable {
  public _id: string;
  public code: string;
  public name: string;
  public synonyms: string[];
  public displayText: string;

  constructor(data: Partial<Icd10Code> = {}) {
    this._id = data.code ?? '';
    this.code = data.code ?? '';
    this.name = data.name ?? '';
    this.synonyms = data.synonyms ?? [];
    this.displayText = this.buildDisplayText();
  }

  private buildDisplayText(): string {
    const parts = [this.code, this.name].filter(Boolean);
    return parts.join(' – ');
  }
}
